export class NoopRunMetadataManager {
    append(key, value) {
        throw new Error("Method not implemented.");
    }
    remove(key, value) {
        throw new Error("Method not implemented.");
    }
    increment(key, value) {
        throw new Error("Method not implemented.");
    }
    decrement(key, value) {
        throw new Error("Method not implemented.");
    }
    stream(key, value) {
        throw new Error("Method not implemented.");
    }
    fetchStream(key, signal) {
        throw new Error("Method not implemented.");
    }
    flush(requestOptions) {
        throw new Error("Method not implemented.");
    }
    refresh(requestOptions) {
        throw new Error("Method not implemented.");
    }
    enterWithMetadata(metadata) { }
    current() {
        throw new Error("Method not implemented.");
    }
    getKey(key) {
        throw new Error("Method not implemented.");
    }
    set(key, value) {
        throw new Error("Method not implemented.");
    }
    del(key) {
        throw new Error("Method not implemented.");
    }
    update(metadata) {
        throw new Error("Method not implemented.");
    }
    get parent() {
        return {
            append: () => this.parent,
            set: () => this.parent,
            del: () => this.parent,
            increment: () => this.parent,
            decrement: () => this.parent,
            remove: () => this.parent,
            stream: () => Promise.resolve({
                [Symbol.asyncIterator]: () => ({
                    next: () => Promise.resolve({ done: true, value: undefined }),
                }),
            }),
            update: () => this.parent,
        };
    }
    get root() {
        return {
            append: () => this.root,
            set: () => this.root,
            del: () => this.root,
            increment: () => this.root,
            decrement: () => this.root,
            remove: () => this.root,
            stream: () => Promise.resolve({
                [Symbol.asyncIterator]: () => ({
                    next: () => Promise.resolve({ done: true, value: undefined }),
                }),
            }),
            update: () => this.root,
        };
    }
}
//# sourceMappingURL=noopManager.js.map